import { HttpClient } from '@angular/common/http';
import { Injectable, OnInit } from '@angular/core';
import { environment } from '../../environments/environment';
import { ISentNotification } from '../interfaces/models';
import { IAuditNotificationRequest } from '../interfaces/models/auditor.model';
import { NotificationTypesEnum } from '../interfaces/models/notification.model';
import { SocketService } from './socket.service';
import { BehaviorSubject } from 'rxjs';
import { SignalRService } from './signal-r.service';
import { NotificationPreferencesService } from './notification-preferences.service';

@Injectable({
  providedIn: 'root'
})
export class NotificationService implements OnInit {
  private domain = environment.domain;
  private base_url = environment.base_url;
  audio: HTMLAudioElement = new Audio('../../../assets/audio/sound.mp3');
  openNotificationSidebar = new BehaviorSubject(false);
  openNotificationSidebar$ = this.openNotificationSidebar.asObservable();

  setNotificationSidebar(status: boolean) {
    this.openNotificationSidebar.next(status);
  }

  constructor(
    private socket: SocketService,
    private signalRService: SignalRService,
    private http: HttpClient,
    private preferencesService: NotificationPreferencesService
  ) {
    // Subscribe to preferences changes to update audio volume
    this.preferencesService.preferences$.subscribe(prefs => {
      this.audio.volume = prefs.volume;
    });
  }
  dir!: "rtl" | "ltr";
  locale!: "ar" | "en";

  ngOnInit(): void {
  };

  push(notification: Partial<ISentNotification>) {
    this.signalRService.sendMessage(notification)
  };

  pushProjectSubmissionRequest(strategyId: number, projectId: number, locale: string) {
    const submissionReqNotification = {
      type: NotificationTypesEnum.submission_request,
      // Don't set receiverIds - let backend populate it
      strategic_plan_id: +strategyId,
      data: {
        type: NotificationTypesEnum.submission_request,
        id: projectId
      },
      locale: locale
    } as ISentNotification;
    console.log("submissionReqNotification", submissionReqNotification);
    this.push(submissionReqNotification)
  };

  pushProjectSubmissionResponse(strategyId: number, projectId: number, in_charge_id: number, locale: string) {
    const submissionReqNotification = {
      type: NotificationTypesEnum.submission_response,
      receiverIds: [in_charge_id],
      strategic_plan_id: strategyId,
      data: {
        type: NotificationTypesEnum.submission_response,
        id: projectId
      },
      locale: locale
    } as ISentNotification;
    this.push(submissionReqNotification)
  };

  pushProjectExecutionNotification(strategyId: number, projectId: number, reasons: string, type: NotificationTypesEnum, locale: string) {
    const notification = {
      type,
      // Don't set receiverIds - let backend populate it
      strategic_plan_id: strategyId,
      data: {
        reasons,
        type,
        id: projectId
      },
      locale: locale
    } as ISentNotification;
    this.push(notification)
  };

  pushAuditRequest(strategyId: number, aduitRequest: IAuditNotificationRequest, locale: string) {
    console.log("pushAuditRequest", {
      type: aduitRequest.type,
      strategic_plan_id: strategyId,
      data: aduitRequest,
      locale: locale
    });

    const auditReqNotification = {
      type: aduitRequest.type,
      strategic_plan_id: +strategyId,
      data: aduitRequest,
      locale: locale
    } as ISentNotification;
    this.push(auditReqNotification)
  };

  markAsRead(notificationId: number) {
    return this.http.put(this.domain + `notifications/${notificationId}/mark-as-read`, {})
  };

  playAudio() {
    if (this.preferencesService.isSoundEnabled()) {
      this.audio.volume = this.preferencesService.getVolume();
      this.audio.play().catch(err => {
        console.warn('Could not play notification sound:', err);
      });
    }
  };

  vibrate() {
    if (this.preferencesService.isVibrationEnabled() && 'vibrate' in navigator) {
      navigator.vibrate(200);
    }
  };

  markAllNotificationsASRead(strategyId: number) {
    return this.http.put(this.domain + `notifications/mark-all-as-read?strategyId=${strategyId}`, {})
  };

  deleteNotification(notificationId: number) {
    return this.http.delete(this.domain + `notifications/${notificationId}`)
  };
};
